import React from 'react';
import { motion } from 'framer-motion';
export function AboutSection() {
  return <section id="about" className="py-24 lg:py-32 px-6 lg:px-12 max-w-[1400px] mx-auto flex flex-col lg:flex-row-reverse items-center gap-16 lg:gap-24" data-id="element-11">
      {/* Right Image (Reversed layout) */}
      <motion.div initial={{
      opacity: 0,
      x: 30
    }} whileInView={{
      opacity: 1,
      x: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8
    }} className="flex-1 w-full relative" data-id="element-12">
        <div className="relative aspect-[4/5] w-full max-w-md mx-auto lg:ml-auto lg:mr-0 overflow-hidden" data-id="element-13">
          <img src="https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?auto=format&fit=crop&q=80&w=1200" alt="Precision Skincare Treatment" className="w-full h-full object-cover" data-id="element-14" />
        </div>
      </motion.div>

      {/* Left Content */}
      <motion.div initial={{
      opacity: 0,
      x: -30
    }} whileInView={{
      opacity: 1,
      x: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8,
      delay: 0.2
    }} className="flex-1 w-full" data-id="element-15">
        <div className="flex items-center gap-4 mb-6" data-id="element-16">
          <span className="w-8 h-[1px] bg-taupe" data-id="element-17"></span>
          <span className="text-taupe-dark text-xs uppercase tracking-[0.3em] font-sans" data-id="element-18">
            About Us
          </span>
          <span className="w-8 h-[1px] bg-taupe" data-id="element-19"></span>
        </div>

        <h2 className="font-serif text-4xl lg:text-5xl font-light leading-tight mb-8 text-black" data-id="element-20">
          Parkway <span className="italic" data-id="element-21">Esthetics</span>
        </h2>

        <p className="font-sans text-black/70 leading-relaxed mb-6 text-lg" data-id="element-22">
          We are experts at scar camouflage services. Jeff Parkway is also an
          expert trainer to hundreds of estheticians and tattoo artists all over
          the world.
        </p>
        <p className="font-sans text-black/70 leading-relaxed mb-10 text-lg" data-id="element-23">
          Our clinic provides specialized vitiligo camouflage services to help
          individuals manage and conceal the effects of vitiligo, offering
          natural-looking results and improved self-esteem.
        </p>

        <a href="#" className="inline-flex items-center gap-3 text-xs uppercase tracking-widest font-sans text-black hover:text-taupe-dark transition-colors group" data-id="element-24">
          Discover More
          <span className="transition-transform duration-300 group-hover:translate-x-2" data-id="element-25">
            →
          </span>
        </a>
      </motion.div>
    </section>;
}